import { PromoRoutesEnum } from 'shared/constants/routes'
import { URLS } from 'shared/constants/urls'

import { SupportCardType } from './types'

export const breakSymbol = '/b/'

export const supportCardsText: SupportCardType[] = [
  {
    id: 1,
    title: 'Выплатим субсидию или\u00A0гарантированный доход',
    link: '#faq',
  },
  {
    id: 2,
    title: 'Подарим вывеску, панель-кронштейн и\u00A0контроллер',
    link: PromoRoutesEnum.signboard,
  },
  {
    id: 3,
    title: 'Научим, как управлять пунктом выдачи и работать с\u00A0товарами',
    link: URLS.learningPortal,
    linkType: 'search',
  },
]
